export default __webpack_public_path__ + "static/media/y1897.168edcbc.mp3";